<template lang="html">
  <div>
    <v-card class="card-size">
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-row justify="start">
        <v-col cols="12" sm="6" md="3" class="ml-3">
          <v-text-field
            v-model="searchQuery"
            @input="filtrar"
            append-icon="search"
            :label="$t('label.pesquisar')"
            single-line
            clearable
            hide-details>
          </v-text-field>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="lista"
        :options.sync="pagination"
        :server-items-length="totalPage"
        :no-data-text="$t('label.tabela_sem_conteudo')"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50],
        }">
        <template v-slot:item.acoes="{ item }">
          <v-tooltip bottom v-if="canAccessCRUD">
            <template v-slot:activator="{ on }">
              <v-btn icon class="mx-0" v-on="on" @click.stop="onEditar(item)">
                <v-icon>edit</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('label.editar') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.id_tipo_uso="{ item }">
          {{ item.idTipoUso }}
        </template>
        <template v-slot:item.nom_tipo_uso="{ item }">
          {{ item.nomTipoUso }}
        </template>
        <template v-slot:item.nom_tipo_acao="{ item }">
          {{ item.nomTipoAcao }}
        </template>
        <template v-slot:item.cod_origem="{ item }">
          {{ item.codOrigem }}
        </template>
        <template v-slot:item.cod_evento="{ item }">
          {{ item.codEvento }}
        </template>
        <template v-slot:item.texto_juridico="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on"> {{ formataTextoJuridico(item.textoJuridico) }} </span>
            </template>
            <span>{{ item.textoJuridico }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.ind_tipo_uso_padrao="{ item }">
          {{ item.indTipoUsoPadrao ? $tc('label.sim', 1): $tc('label.nao', 1) }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script type="text/javascript">
import { generateComputed } from '@/common/functions/roles-computed-generator';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      tipoUsoResources: this.$api.tipoUso(this.$resource),
      lista: [],
      esperar: false,
      headers: [
        { text: this.$tc('label.id', 1), value: 'id_tipo_uso', sortable: true },
        { text: this.$tc('label.tipo_acao', 1), value: 'nom_tipo_acao', sortable: true },
        { text: this.$tc('label.tipo_uso', 1), value: 'nom_tipo_uso', sortable: true },
        { text: this.$tc('label.cod_origem', 1), value: 'cod_origem', sortable: true },
        { text: this.$tc('label.cod_evento', 1), value: 'cod_evento', sortable: true },
        { text: this.$tc('label.texto_juridico', 1), value: 'texto_juridico', sortable: true },
        { text: this.$tc('label.padrao', 1), value: 'ind_tipo_uso_padrao', sortable: true },
      ],
      pagination: {},
      totalPage: 0,
      searchQuery: '',
    };
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
    searchQuery() {
      this.pagination.page = 1;
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filtrar();
      }, 500);
    },
  },
  props: {
    title: String,
  },
  computed: {
    ...generateComputed('TIPO_USO', [
      'canAccessCRUD',
    ]),
    somenteLeitura() {
      return !this.canAccessCRUD;
    },
    ...mapGetters('implantacao', [
      'chaveEmpresa',
    ]),
    isAmbienteKabum() {
      return this.chaveEmpresa === 'KABUM';
    },
  },
  methods: {
    formataTextoJuridico(texto) {
      if (!texto) {
        return '';
      }
      if (texto.length < 50) {
        return texto;
      }

      return texto.substring(0, 50).concat('...');
    },
    buscar() {
      const params = {
        nome: this.searchQuery,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
      };

      if (this.isAmbienteKabum) {
        params.isKabum = this.isAmbienteKabum;
      }

      this.tipoUsoResources.listar(params).then((response) => {
        this.lista = response.data.resposta;
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.pararEsperar();
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar();
      }, 1000);
    },
    getSearchQuery() {
      return this.searchQuery;
    },
    onEditar(tipoUso) {
      this.$emit('PESQUISA_TIPO_USO_EDITAR', tipoUso);
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
  },
  mounted() {
    if (this.somenteLeitura) return;
    this.headers.unshift({
      text: '',
      value: 'acoes',
      sortable: false,
      width: '2%',
      align: 'center',
    });
  },
};
</script>
